/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Codecs_DescInputs */

const en_fc_home_features_codecs_desc = /** @type {(inputs: Fc_Home_Features_Codecs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H.264, HEVC, ProRes, VP9, AV1, AAC and Opus decoders written in Rust. Export to H.264 MP4, ProRes 422 HQ, PNG sequences or GIF.`)
};

/**
* | output |
* | --- |
* | "H.264, HEVC, ProRes, VP9, AV1, AAC and Opus decoders written in Rust. Export to H.264 MP4, ProRes 422 HQ, PNG sequences or GIF." |
*
* @param {Fc_Home_Features_Codecs_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_codecs_desc = /** @type {((inputs?: Fc_Home_Features_Codecs_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Codecs_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_codecs_desc(inputs)
});
export { fc_home_features_codecs_desc as "fc.home.features.codecs.desc" }